import React from "react";
import { Col, ContentLoader, Flex, Row } from "../../components";

const ItemCardSkeleton = ({ index }: { index: number }) => (
  <ContentLoader
    uniqueKey={`menu-item-card-${index}`}
    viewBox="0 0 320 420"
    className="w-full"
    style={{ width: "100%", height: "auto" }}
  >
    <rect x="0" y="0" rx="12" ry="12" width="320" height="220" />
    <rect x="16" y="240" rx="4" ry="4" width="200" height="18" />
    <rect x="16" y="270" rx="4" ry="4" width="260" height="12" />
    <rect x="16" y="292" rx="4" ry="4" width="180" height="12" />
    <rect x="16" y="330" rx="4" ry="4" width="90" height="18" />
    <rect x="16" y="365" rx="8" ry="8" width="288" height="40" />
  </ContentLoader>
);

const TabsSkeleton = () => (
  <div className="sticky top-0 left-0 right-0 z-[100] bg-background">
    <div className="px-page">
      <Flex
        align="center"
        justify="center"
        gap={"0.8rem"}
        className="py-[30px] overflow-hidden"
      >
        {React.Children.toArray(
          Array.from({ length: 5 }).map((_, i) => (
            <ContentLoader
              uniqueKey={`menu-tab-${i}`}
              width={110}
              height={32}
              viewBox="0 0 110 32"
              className="shrink-0"
            >
              <rect x="0" y="0" rx="8" ry="8" width="110" height="32" />
            </ContentLoader>
          )),
        )}
      </Flex>
    </div>
  </div>
);

const Skeleton = ({ hasHero }: { hasHero?: boolean }) => (
  <div className="bg-background">
    {hasHero && (
      <div className="mt-[-2.4rem] z-[2] relative px-page">
        <ContentLoader
          uniqueKey="menu-hero"
          className="w-full rounded-[2rem] overflow-hidden"
          style={{ width: "100%", height: "clamp(18rem, 32vw, 40rem)" }}
          viewBox="0 0 1200 400"
          preserveAspectRatio="none"
        >
          <rect x="0" y="0" rx="20" ry="20" width="1200" height="400" />
        </ContentLoader>
      </div>
    )}

    <TabsSkeleton />

    <div className="px-page pt-[4rem] pb-[100px] mobile:pt-[2rem]">
      <ContentLoader
        uniqueKey="menu-search"
        className="m-20-b w-full"
        height={48}
        viewBox="0 0 800 48"
        style={{ width: "100%" }}
      >
        <rect x="0" y="0" rx="8" ry="8" width="800" height="48" />
      </ContentLoader>

      <Flex vertical gap={"30px"}>
        <Row
          gutter={[
            { xs: 8, lg: 16 },
            { xs: 8, lg: 16 },
          ]}
        >
          {React.Children.toArray(
            Array.from({ length: 6 }).map((_, i) => (
              <Col xs={24 / 2} sm={24 / 2} md={24 / 2} lg={24 / 3}>
                <ItemCardSkeleton index={i} />
              </Col>
            )),
          )}
        </Row>
      </Flex>
    </div>
  </div>
);

export default Skeleton;
